var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-form"},[_c('h3',{staticClass:"pl-3"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }